export default "__VITE_ASSET__5c7e542a__"